import * as React from 'react';
import loadable from '@loadable/component';
import styled from 'styled-components';

import { GlobalStyles } from '../client/theme/GlobalStyles';
import { Route, Switch } from 'react-router';
import { Footer } from '@pm/gui';
import { Header } from './components/layout/header';
import { Modal, ModalContextProvider } from './components/ui/modal/modal';

import { SiteContextProvider } from './utils/context/site';

const Home = loadable(
  () => import(/* webpackPrefetch: true */ './components/containers/Home')
);

const Office = loadable(
  () => import(/* webpackPrefetch: true */ './components/containers/Office')
);

const News = loadable(
  /* webpackPrefetch: true */ () => import('./components/containers/News')
);

const PortalNews = loadable(
  () => import(/* webpackPrefetch: true */ './components/containers/PortalNews')
);

const PortalServices = loadable(
  () =>
    import(/* webpackPrefetch: true */ './components/containers/PortalServices')
);

const Admin = loadable(
  () => import(/* webpackPrefetch: true */ './components/containers/Admin')
);

const OurCustomers = loadable(
  () =>
    import(/* webpackPrefetch: true */ './components/containers/OurCustomers')
);

const PortalBuyDevelopment = loadable(
  () =>
    import(
      /* webpackPrefetch: true */ './components/containers/PortalBuyDevelopment'
    )
);

const PortalPageContent = loadable(
  () =>
    import(
      /* webpackPrefetch: true */ './components/containers/PortalPageContent'
    )
);

const NoMatch = loadable(
  () => import(/* webpackPrefetch: true */ './components/containers/404')
);

const ServiceItem = loadable(
  () =>
    import(/* webpackPrefetch: true */ './components/layout/SectionServiceItem')
);

const Contact = loadable(
  () => import(/* webpackPrefetch: true */ './components/containers/Contact')
);

export const App: React.FC = () => {
  return (
    <>
      <SiteContextProvider>
        <ModalContextProvider>
          <GlobalStyles />
          <Route
            exact
            path="/:p1?/:p2?/:p3?/:p4?/:p5?"
            render={(props) => <Header {...props} />}
          />
          <RouteWrapper>
            <Switch>
              <Route exact path="/" component={Home} />
              {/* Generelle tjenester */}
              <Route exact path="/tjeneste-1" component={ServiceItem} />
              {/* Kontor */}
              <Route exact path="/kontor/:urltag" component={Office} />
              <Route exact path="/kontor/:urltag/kontakt" component={Contact} />
              <Route
                exact
                path="/kontor/:urltag/nyheter"
                component={PortalNews}
              />
              <Route
                exact
                path="/kontor/:urltag/kommerforsalg"
                component={PortalPageContent}
              />
              <Route
                exact
                path="/kontor/:urltag/nyheter/:slug"
                component={News}
              />
              <Route
                exact
                path="/kontor/:urltag/tjeneste/:slug"
                component={News}
              />
              <Route
                exact
                path="/kontor/:urltag/artikkel/:slug"
                component={News}
              />
              <Route
                exact
                path="/kontor/:urltag/kunde/:slug"
                component={News}
              />
              <Route exact path="/artikkel/:slug" component={News} />
              <Route
                exact
                path="/kontor/:urltag/tjenester"
                component={PortalServices}
              />
              {/*           <Route exact path="/kontor/:urltag/kontaktoss" component={Office} /> */}
              <Route
                exact
                path="/kontor/:urltag/vaarekunder"
                component={OurCustomers}
              />
              <Route
                exact
                path="/kontor/:urltag/kjope"
                component={PortalBuyDevelopment}
              />
              <Route
                path="/admin/:kontor?/:option?/:category?"
                component={Admin}
              />
              <Route component={NoMatch} />
            </Switch>
          </RouteWrapper>

          <Footer />

          <Modal />
        </ModalContextProvider>
      </SiteContextProvider>
    </>
  );
};

const RouteWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
`;
